"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const menuCategories = [{
  id: 1,
  title: "Water Damage Restoration",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680241/img/pueblo_water_damage_restoration.png",
  link: "/ServicesPage"
}, {
  id: 2,
  title: "Emergency Flood Cleanup",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680241/img/pueblo_flood_cleanup_service.png",
  link: "/ServicesPage"
}, {
  id: 3,
  title: "Mold Prevention & Removal",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680241/img/pueblo_mold_prevention.png",
  link: "/ServicesPage"
}];
export default function FromOurKitchenToYourTable() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224081" id="emergency-restoration-solutions" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-black mb-6 tracking-tighter uppercase text-primary">
            Emergency Restoration Solutions
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-default text-lg">
            We connect you with Pueblo's fastest responders. Standing water causes structural damage and mold growth with every passing hour — getting the right professional on-site quickly makes all the difference.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {menuCategories.map((category, i) => <div key={category.id} data-index={i} className="h-[500px] md:h-[700px] w-full">
              <Link to={category.link} className="block w-full h-full group">
                <Card className="relative overflow-hidden w-full h-full rounded-md border-0 bg-transparent p-0 m-0 gap-0 shadow-lg">
                  {}
                  <img src={category.image} alt={category.title} className="absolute inset-0 w-full h-full object-cover transition-all duration-700 ease-in-out group-hover:scale-105 group-hover:saturate-100 group-hover:brightness-75" />
                  
                  {}
                  <div className="absolute inset-0 bg-primary/80 transition-colors duration-700 group-hover:bg-primary/40" />

                  {}
                  <CardContent className="relative h-full flex items-center justify-center p-8 bg-transparent">
                    <div className="flex flex-col items-center gap-4">
                      <h3 className="font-default text-3xl md:text-4xl text-white font-black text-center opacity-100 translate-y-0 transition-all duration-700 ease-out group-hover:-translate-y-4 drop-shadow-2xl uppercase tracking-tighter">
                        {category.title}
                      </h3>
                      <span className="font-mono text-sm bg-primary text-white px-6 py-3 rounded-md opacity-0 translate-y-8 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0 shadow-xl border border-white/20">
                        VIEW PROCESS
                      </span>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}